import { useThree } from "@react-three/fiber";
import { useContext, useEffect } from "react"

import AppContext from "../../hooks/AppConext"

export const ConnectEvents = () => {
  const { selected } = useContext(AppContext)
  const { events } = useThree()

  useEffect(() => {
    const root = document.getElementById("root")
    events.connect(root)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (selected) {
      events.disconnect()
      const root = document.querySelector("#root")
      events.connect(root)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])
}
